<app-error-page [errorStatus]="errorStatus">
  <app-error-page-title>
    {{ 'ERROR.500_PAGE.TITLE' | translate }}
  </app-error-page-title>
  <app-error-page-message>
      {{ 'ERROR.500_PAGE_MESSAGE' | translate }}
  </app-error-page-message>
  <app-error-page-action>
    <button
      mm-button
      class="not-found__action"
      (click)="refreshPage()"
      color="primary"
      size="large"
    >
      {{ 'ERROR.500_PAGE_BUTTON_LABEL' | translate }}
    </button>
  </app-error-page-action>
</app-error-page>
